import { Link } from "react-router-dom";
import styled from "styled-components/macro";

import icon_burger_mobile from "../../assets/icons/icon_burger_mobile.svg"
import { ReactComponent as SearchIcon } from "../../assets/icons/icon_search_mobile.svg";
import icon_shevron from "../../assets/icons/icon_shevron.svg"

export const HeaderShell = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding-top: 18px;

  @media (max-width: 979px) {
    position: static;
    padding-top: 0;
  }
`;

export const HeaderContainer = styled.header`
  width: 100%;
  max-width: 1320px;
  height: 64px;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.72);
  margin: 0 auto;
  padding: 0 15px;
  border-radius: 50px;
  border: 1px solid rgba(20, 20, 20, 0.14);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.72),
    0 12px 32px rgba(20, 20, 20, 0.08);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(20px);

  @media (max-width: 1439px) {
    max-width: calc(100% - 24px);
  }

  @media (max-width: 979px) {
    height: 58px;
    margin: 12px auto;
    padding: 0 15px;
    background: #fff;
    border: 1px solid #141414;
    box-shadow: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  gap: 10px;

  @media (min-width: 1024px) and (max-width: 1439px) {
    gap: 0;
  }

  @media (max-width: 979px) {
    display: none;
  }
`

export const MobileButton = styled.div`
  display: none;
  padding: 12px;
  cursor: pointer;

  @media (max-width: 979px) {
    display: block;
    padding: 15px;
  }
`

export const SearchMobile = styled(SearchIcon)`
  width: 18px;
  height: 18px;
  display: block;
`

export const Logo = styled.img`
  position: absolute;
  cursor: pointer;
  width: 157px;
  height: 32px;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;

  @media (max-width: 979px) {
    width: 147px;
    height: 30px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  gap: 10px;

  @media (min-width: 1024px) and (max-width: 1439px) {
    gap: 0;
  }

  @media (max-width: 979px) {
    display: none;
  }
`

export const BurgerMobile = styled.div`
  width: 24px;
  height: 10px;
  display: none;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${icon_burger_mobile});
  cursor: pointer;

  @media (max-width: 979px) {
    display: block;
  }
`

export const HeaderMenuButton = styled.div`
  display: inline-flex;
  position: relative;
  border-radius: 16px;
  align-items: center;
  padding: 5px 12px;
  transition: 0.4s;
  cursor: pointer;

  &:hover {
     transition: 0.4s;
     background-color: #DDDEE4;
  }
`

export const HeaderButton = styled(Link)`
  display: inline-flex;
  position: relative;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  align-items: center;
  padding: 5px 12px;
  transition: 0.4s;

  &:hover {
    transition: 0.4s;
    background-color: #DDDEE4;
  }
`

export const Icon = styled.span`
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 10px;
  height: 7px;
  margin-left: 7px;
  background-image: url(${icon_shevron});
  transition: 0.3s;
`

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 10;
  display: none;
  flex-direction: column;
  background-color: #E8E9ED;
  border-radius: 16px;
  width: 354px;
`

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${DropdownMenu} {
    display: flex;
  }

  &:hover ${HeaderButton} {
    background-color: #DDDEE4;
  }

  &:hover ${Icon} {
    transform: rotate(-180deg);
    transition: 0.3s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    height: 20px;
    width: 100px;
  }
`

export const IconDot = styled.span`
  display: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 7px;
  background-color: #1983FF;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
`

export const MenuItem = styled(Link)`
  position: relative;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
  padding: 8px 12px;
  color: inherit;

  &:hover {
    color: #1983FF;
  }

  &:hover ${IconDot} {
   display: block;
  }
`;

export const TGButton = styled.a`
  padding: 5px 12px;
  background-color: #0088FF36;
  color: #050F25;
  border: 1px solid #000;
  cursor: pointer;
  border-radius: 16px;
  text-decoration: none;
  transition: 0.4s;

  &:hover {
    background-color: black;
    color: white;
    transition: 0.4s;
  }

  @media (max-width: 430px) {
    display: none;
  }
`
